import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };

  return (
    <footer className="bg-stone-900 text-white">
      <div className="w-full px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl font-bold tracking-tight">
              {t('footer.brand')}
            </h3>
            <p className="mt-4 text-sm text-stone-400 leading-relaxed max-w-xs">
              YOYBUY Spreadsheet — лучшая система покупок товаров из Китая. Экономьте до 40% на каждом заказе.
            </p>
          </div>

          {/* Links column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-stone-300 mb-5">
              {t('footer.links')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-sm text-stone-400 hover:text-white transition-colors">
                  {t('footer.home')}
                </a>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-stone-400 hover:text-white transition-colors"
                >
                  {t('footer.categories')}
                </a>
              </li>
              <li>
                <a href="/article/chto-takoe-yoybuy-spreadsheet" className="text-sm text-stone-400 hover:text-white transition-colors">
                  {t('footer.articles')}
                </a>
              </li>
              <li>
                <a
                  href={`${mainSiteUrl}/compare-platforms/`}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-stone-400 hover:text-white transition-colors"
                >
                  {t('footer.compare')}
                </a>
              </li>
              <li>
                <a
                  href={`${mainSiteUrl}/spreadsheet-tool/`}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-stone-400 hover:text-white transition-colors"
                >
                  {t('footer.spreadsheet')}
                </a>
              </li>
            </ul>
          </div>

          {/* Social column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-stone-300 mb-5">
              {t('footer.social')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 text-sm text-stone-400 hover:text-white transition-colors"
                >
                  <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 text-sm text-stone-400 hover:text-white transition-colors"
                >
                  <i className="ri-youtube-line w-4 h-4 flex items-center justify-center" />
                  YouTube
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 text-sm text-stone-400 hover:text-white transition-colors"
                >
                  <i className="ri-facebook-line w-4 h-4 flex items-center justify-center" />
                  Facebook
                </a>
              </li>
            </ul>
          </div>

          {/* Subscribe column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-stone-300 mb-5">
              {t('footer.subscribe')}
            </h4>
            <form onSubmit={handleSubscribe} className="flex items-center gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('footer.subscribePlaceholder')}
                className="flex-1 px-4 py-2.5 bg-stone-800 border border-stone-700 rounded-lg text-sm text-white placeholder-stone-500 focus:outline-none focus:border-stone-500"
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center bg-white text-stone-900 rounded-full hover:bg-stone-100 transition-colors shrink-0"
              >
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </button>
            </form>
            {status === 'success' && (
              <p className="mt-2 text-xs text-emerald-400">Спасибо за подписку!</p>
            )}
          </div>
        </div>
      </div>

      {/* Bottom bar with brand text */}
      <div className="border-t border-stone-800">
        <div className="w-full px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-500">{t('footer.copyright')}</p>
          <span className="font-heading text-4xl font-bold text-stone-800 select-none">
            YOYBUY
          </span>
        </div>
      </div>
    </footer>
  );
}